// Mini Projects Data
// Images are imported from centralized assets
import { ProjectImages } from "@/assets/images";

const miniProjectData = [
  {
    translationKey: "vue-weather-app",
    siteLink: "https://kitty-vue-weather-app.netlify.app/",
    GhLink: "https://github.com/Netsujr/vue-weather-app",
    imageKey: "weather",
  },
  {
    translationKey: "typescript-tasks",
    siteLink: "https://typescript-taskapp.netlify.app/",
    GhLink: "https://github.com/Netsujr/typescript-taskapp",
    imageKey: "task",
  },
  {
    translationKey: "quiz-night",
    siteLink: "https://renato-quiz-night.netlify.app/",
    GhLink: "https://github.com/Netsujr/quiz-night",
    imageKey: "quiz",
  },
  {
    translationKey: "typescript-notes",
    siteLink: "https://typescript-notes.netlify.app/",
    GhLink: "https://github.com/Netsujr/typescript-notes-practice",
    imageKey: "notes",
  },
  {
    translationKey: "js-snake-game",
    siteLink: "https://netsujr.github.io/JS_SnakeGame/",
    GhLink: "https://github.com/Netsujr/JS_SnakeGame",
    imageKey: "snake",
  },
  {
    translationKey: "javascript-calculator",
    siteLink: "https://netsujr.github.io/JS_Calculator/",
    GhLink: "https://github.com/Netsujr/JS_Calculator",
    imageKey: "calculator",
  },
  {
    translationKey: "rock-paper-scissors",
    siteLink: "https://distracted-mahavira-252b8c.netlify.app/",
    GhLink: "https://github.com/Netsujr/rock-paper-scissors",
    imageKey: "rps",
  },
  {
    translationKey: "javascript-blackjack",
    siteLink: "https://hungry-mestorf-4efc96.netlify.app/",
    GhLink: "https://github.com/Netsujr/javascript_blackjack",
    imageKey: "blackjack",
  },
  {
    translationKey: "tinyme-studios",
    siteLink: "https://reverent-hermann-98a8cb.netlify.app/",
    GhLink: "https://github.com/Netsujr/TinymeStudios",
    imageKey: "tinyMe",
  },
  {
    translationKey: "theme-toggler",
    siteLink: "https://naughty-einstein-a30f95.netlify.app/",
    GhLink: "https://github.com/Netsujr/Changing_Themes",
    imageKey: "theme",
  },
  {
    translationKey: "js-counter",
    siteLink: "https://modest-colden-be1fdb.netlify.app/",
    GhLink: "https://github.com/Netsujr/simple_counter_js",
    imageKey: "counter",
  },
  {
    translationKey: "js-grocery-list",
    siteLink: "https://thirsty-austin-932dc8.netlify.app",
    GhLink: "https://github.com/Netsujr/JavaScript_grocery_list",
    imageKey: "grocery",
  },
  {
    translationKey: "my-webstore",
    siteLink: "",
    GhLink: "",
    imageKey: "comingSoon",
  },
];

// Process mini project data to add images
const processedMiniProjectData = miniProjectData.map((project) => ({
  ...project,
  cardImg:
    ProjectImages.mini[project.imageKey] || ProjectImages.mini.comingSoon,
}));

export default processedMiniProjectData;
